import { cx } from '@linaria/core';
import { baseTheme } from 'styles/utils';
import { styled } from '@linaria/react';
export type SpinnerSize = 'small' | 'large';
export interface CircleLoaderProps {
  className?: string;
  /** The size of the loader in pixels */
  size?: SpinnerSize;
  borderSize?: number;
  primaryColor?: string;
  secondaryColor?: string;
}
export function CircleLoader({
  className,
  size = 'large',
  borderSize = 4,
  primaryColor = baseTheme.light.colors.primary600,
  secondaryColor = 'rgba(0, 0, 0, 0.1)'
}: CircleLoaderProps): JSX.Element {
  const sizeCls = `size-${size}`;
  return <Spinner size={size} borderSize={borderSize} className={cx(sizeCls, className)} primaryColor={primaryColor} secondaryColor={secondaryColor} />;
}
const Spinner = /*#__PURE__*/styled("div")({
  name: "Spinner",
  class: "omponents__PlatformResourceVersionSelector__CircleLoader_tsx-Spinner-ss148yz",
  vars: {
    "ss148yz-0": [({
      borderSize,
      secondaryColor
    }) => `${borderSize}px solid ${secondaryColor}`],
    "ss148yz-1": [({
      primaryColor = baseTheme.light.colors.primary600
    }) => primaryColor],
    "ss148yz-2": [({
      borderSize
    }) => `${borderSize}px`]
  }
});

require("./CircleLoader.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./CircleLoader.tsx");